import React from 'react';
import { Briefcase, Users, Film, Clock, Award, Folder } from 'lucide-react';
import { Button } from './ui/button';

export const AdditionalFeatures = ({ onEnrollClick }) => {
  const features = [
    {
      icon: Briefcase,
      title: 'Dedicated 100% Job Assistance',
      description: 'We help students with 100% job placement assistance by creating resumes and sharing interview tips.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: Users,
      title: 'Personal Attention & Guidance',
      description: 'Individual focus with customized learning paths tailored to your skill level and career goals.',
      color: 'from-pink-500 to-orange-500'
    },
    {
      icon: Film,
      title: 'Learn with Professional Footage',
      description: 'Work with real professional footage used in the industry for authentic learning experience.',
      color: 'from-orange-500 to-amber-500'
    },
    {
      icon: Clock,
      title: 'Unlimited Lab Hours',
      description: 'Practice as much as you want with unlimited access to our editing labs and workstations.',
      color: 'from-amber-500 to-yellow-500'
    },
    {
      icon: Award,
      title: 'Professional Trainers',
      description: 'Highly experienced trainers from the media industry teaching editing theory, special effects, and transitions.',
      color: 'from-yellow-500 to-green-500'
    },
    {
      icon: Folder,
      title: 'Project-Based Learning',
      description: 'Create your own professional portfolio with real projects and get certified upon completion.',
      color: 'from-green-500 to-teal-500'
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
            What Makes Us
            <span className="block bg-gradient-to-r from-purple-600 to-orange-600 bg-clip-text text-transparent mt-2">
              Different
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Experience world-class training with features that ensure your success
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <div 
                key={idx}
                className="group bg-gradient-to-br from-slate-50 to-purple-50 rounded-3xl p-8 hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 border border-slate-100"
                style={{ animationDelay: `${idx * 100}ms` }}
              >
                <div className={`inline-flex p-4 rounded-2xl bg-gradient-to-br ${feature.color} mb-6 transform group-hover:rotate-6 transition-transform duration-500`}>
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Trainers & Project Works */}
        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-3xl p-8 text-white">
            <h3 className="text-3xl font-bold mb-4">Expert Trainers</h3>
            <p className="text-purple-100 leading-relaxed">
              Our trainers are highly professional and well-experienced in the media industry. With their incomparable experience and knowledge, they teach you all the necessary editing skills like Editing theory, Special effects, Synchronization, Transitions and so on.
            </p>
          </div>
          <div className="bg-gradient-to-br from-orange-600 to-amber-600 rounded-3xl p-8 text-white">
            <h3 className="text-3xl font-bold mb-4">Portfolio Building</h3>
            <p className="text-orange-100 leading-relaxed">
              Every individual student should create his/her own portfolio for professional personalities. Certificates will be provided on successful completion of the course. We help you build a portfolio that stands out.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Button
            onClick={onEnrollClick}
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-12 py-6 rounded-full text-lg font-semibold transform hover:scale-105 transition-all duration-300 border-0"
          >
            Learn More
          </Button>
        </div>
      </div>
    </section>
  );
};
